module.exports = __webpack_public_path__ + "img/anlib.ee353ac7.png";